import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold" }, " Número de chasis (VIN)", -1)
const _hoisted_3 = ["required", "disabled"]
const _hoisted_4 = { class: "text-danger" }
const _hoisted_5 = {
  key: 0,
  class: "text-danger mt-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(!_ctx.meta.valid ? 'input-error': '')
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.field) = $event)),
        autocomplete: "false",
        type: "text",
        placeholder: "Últimos 6 dígitos del chasis",
        required: _ctx.required,
        class: "input",
        disabled: _ctx.disabled || _ctx.validating,
        maxlength: "6"
      }, null, 8, _hoisted_3), [
        [_vModelText, _ctx.field]
      ])
    ]),
    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.errorMessage), 1),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true)
  ], 2))
}